module.exports = __webpack_public_path__ + "img/builder-1.ca992232.webp";